var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","stroke-width":"1.7","stroke-linecap":"round","stroke-linejoin":"round","aria-hidden":"true"}},[_c('path',{attrs:{"d":_vm.paths[_vm.name] || _vm.paths.chart}})])
}
var staticRenderFns = []

export { render, staticRenderFns }